import React, { useCallback } from "react";
import clsx from "clsx";
import {
  StyledChatAvatar,
  StyledChatListItem,
  StyledChatListItemContent,
} from "../../index.styled";
import { StyledChatUserAvatarView } from "../../userInfo.styled";
import { useNavigate, useParams } from "react-router-dom";
import { ITelegramBotUser } from "@lib/types/TelegramChatBot";
import { ManagerName } from "@lib/components/MiniComponents/Others";

type ConnectionItemProps = {
  item: ITelegramBotUser;
};

const ConnectionItem: React.FC<ConnectionItemProps> = (props) => {
  const { item } = props;
  const { tabId, chatId } = useParams();
  const navigate = useNavigate();

  const setSelectedUser = useCallback((item: ITelegramBotUser) => {
    navigate(`/messages/telegram/${tabId}/${item.chatId}`);
  }, []);

  return (
    <StyledChatListItem
      className={clsx("item-hover", {
        active: chatId === item.chatId,
      })}
      onClick={() => setSelectedUser(item)}
    >
      <StyledChatUserAvatarView>
        <StyledChatAvatar>
          {item.manager?.firstName?.slice(0, 1)}
          {item.manager?.lastName?.slice(0, 1)}
        </StyledChatAvatar>
      </StyledChatUserAvatarView>
      <StyledChatListItemContent>
        <h3>
          <ManagerName manager={item.manager} />
        </h3>
        <p>Chat ID: {item.chatId}</p>
      </StyledChatListItemContent>
    </StyledChatListItem>
  );
};

export default ConnectionItem;
